<template>
  <div class="main-container">
    <div class="main-title-container">
      <div class="main-title">{{ $t('imageSplitter.title') }}</div>
      <div class="main-description">{{ $t('imageSplitter.description') }}</div>
    </div>
    <div class="main-content-container" v-show="!uploadFile">
      <div class="main-upload-container">
        <div class="main-upload">
          <img src="./assets/upload.webp" alt="upload" class="main-upload-icon">
          <div class="main-upload-text">
            {{ $t('imageSplitter.uploadText') }}
          </div>
          <div class="main-upload-button cursor-pointer" @click="handleUpload">
            <i class="el-icon-upload"></i>
            {{ $t('imageSplitter.uploadButtonText') }}
          </div>
          <input type="file" ref="uploadInput" class="main-upload-input" accept="image/*" @change="handleFileChange" />
        </div>
      </div>
    </div>
    <div class="main-split-container" v-if="uploadFile">
      <div class="main-split-mode">
        <div class="main-split-mode-title">{{ $t('imageSplitter.splitMode') }}</div>
        <RowsInput v-model="rows" :max="maxRows" :min="minRows" class="split-rows-input" @onChange="handleInputChange">
          <div class="rows-input-solt">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
              width="11.2692597694695" height="11.2692597694695" viewBox="0 0 11.2692597694695 11.2692597694695">
              <g
                transform="matrix(0.001787617802619934,0.99992436170578,-0.99992436170578,0.001787617802619934,11.229039890049616,-11.248298202743005)">
                <path
                  d="M16.249149069190025,1.25C16.249149069190025,1.25,12.499149069190025,1.25,12.499149069190025,1.25C12.499149069190025,1.25,12.499149069190025,10,12.499149069190025,10C12.499149069190025,10,16.249149069190025,10,16.249149069190025,10C16.249149069190025,10,16.249149069190025,1.25,16.249149069190025,1.25C16.249149069190025,1.25,16.249149069190025,1.25,16.249149069190025,1.25ZM17.499149069190025,1.25C17.499149069190025,1.25,17.499149069190025,10,17.499149069190025,10C17.499149069190025,10,21.249149069190025,10,21.249149069190025,10C21.249149069190025,10,21.249149069190025,1.25,21.249149069190025,1.25C21.249149069190025,1.25,17.499149069190025,1.25,17.499149069190025,1.25C17.499149069190025,1.25,17.499149069190025,1.25,17.499149069190025,1.25ZM11.874149069190025,0C11.874149069190025,0,21.874149069190025,0,21.874149069190025,0C22.039849069190026,2.77556e-16,22.198849069190025,0.0658481,22.316049069190026,0.183058C22.433249069190026,0.300269,22.499149069190025,0.45924,22.499149069190025,0.625C22.499149069190025,0.625,22.499149069190025,10.625,22.499149069190025,10.625C22.499149069190025,10.7907,22.433249069190026,10.9497,22.316049069190026,11.0669C22.198849069190025,11.1841,22.039849069190026,11.25,21.874149069190025,11.25C21.874149069190025,11.25,11.874149069190025,11.25,11.874149069190025,11.25C11.708389069190025,11.25,11.549418069190025,11.1841,11.432207069190026,11.0669C11.314997169190026,10.9497,11.249149069190025,10.7907,11.249149069190025,10.625C11.249149069190025,10.625,11.249149069190025,0.625,11.249149069190025,0.625C11.249149069190025,0.45924,11.314997169190026,0.300269,11.432207069190026,0.183058C11.549418069190025,0.0658481,11.708389069190025,2.77556e-16,11.874149069190025,0C11.874149069190025,0,11.874149069190025,0,11.874149069190025,0Z"
                  fill="#333030" fill-opacity="1" />
              </g>
            </svg>
            {{ $t('imageSplitter.rows') }}:
          </div>
        </RowsInput>
        <RowsInput v-model="columns" :max="maxColumns" :min="minColumns" @onChange="handleInputChange">
          <div class="rows-input-solt">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
              width="15.000000197028447" height="15.000000197028447"
              viewBox="0 0 15.000000197028447 15.000000197028447">
              <defs>
                <clipPath id="master_svg0_11_09264">
                  <rect x="0" y="1.970284468910677e-7" width="15" height="15" rx="0" />
                </clipPath>
              </defs>
              <g transform="matrix(1,-1.3135229792737846e-8,1.3135229792737846e-8,1,-2.5880139256204187e-15,0)"
                clip-path="url(#master_svg0_11_09264)">
                <g>
                  <g></g>
                  <g>
                    <path
                      d="M6.875,3.125000197028447C6.875,3.125000197028447,3.125,3.125000197028447,3.125,3.125000197028447C3.125,3.125000197028447,3.125,11.875000197028447,3.125,11.875000197028447C3.125,11.875000197028447,6.875,11.875000197028447,6.875,11.875000197028447C6.875,11.875000197028447,6.875,3.125000197028447,6.875,3.125000197028447C6.875,3.125000197028447,6.875,3.125000197028447,6.875,3.125000197028447ZM8.125,3.125000197028447C8.125,3.125000197028447,8.125,11.875000197028447,8.125,11.875000197028447C8.125,11.875000197028447,11.875,11.875000197028447,11.875,11.875000197028447C11.875,11.875000197028447,11.875,3.125000197028447,11.875,3.125000197028447C11.875,3.125000197028447,8.125,3.125000197028447,8.125,3.125000197028447C8.125,3.125000197028447,8.125,3.125000197028447,8.125,3.125000197028447ZM2.5,1.875000197028447C2.5,1.875000197028447,12.5,1.875000197028447,12.5,1.875000197028447C12.6657,1.8750001970284471,12.8247,1.9408482970284469,12.9419,2.058058197028447C13.0591,2.175269197028447,13.125,2.3342401970284468,13.125,2.500000197028447C13.125,2.500000197028447,13.125,12.500000197028447,13.125,12.500000197028447C13.125,12.665700197028446,13.0591,12.824700197028447,12.9419,12.941900197028447C12.8247,13.059100197028448,12.6657,13.125000197028447,12.5,13.125000197028447C12.5,13.125000197028447,2.5,13.125000197028447,2.5,13.125000197028447C2.33424,13.125000197028447,2.175269,13.059100197028448,2.058058,12.941900197028447C1.9408481,12.824700197028447,1.8750000000000002,12.665700197028446,1.875,12.500000197028447C1.875,12.500000197028447,1.875,2.500000197028447,1.875,2.500000197028447C1.875,2.3342401970284468,1.9408481,2.175269197028447,2.058058,2.058058197028447C2.175269,1.9408482970284469,2.33424,1.8750001970284471,2.5,1.875000197028447C2.5,1.875000197028447,2.5,1.875000197028447,2.5,1.875000197028447Z"
                      fill="#333030" fill-opacity="1" />
                  </g>
                </g>
              </g>
            </svg>
            {{ $t('imageSplitter.columns') }}:
          </div>
        </RowsInput>
      </div>
      <div class="main-split-preview">
        <div class="main-split-mode-title main-split-preview-title">{{ $t('imageSplitter.preview') }}</div>
        <div class="main-split-preview-image">
          <img :src="imageLoading ? uploadFile : splitImagesAll" alt="preview" draggable="false">
        </div>
      </div>
      <div class="main-split-operation">
        <div class="main-split-operation-item cursor-pointer main-split-clear" @click="handleClear">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
            width="16.66666603088379" height="16.66666603088379" viewBox="0 0 16.66666603088379 16.66666603088379">
            <g>
              <path
                d="M5,15C5,15,5,10.8333,5,10.8333C5,10.8333,6.66667,10.8333,6.66667,10.8333C6.66667,10.8333,6.66667,15,6.66667,15C6.66667,15,14.1667,15,14.1667,15C14.1667,15,14.1667,9.16667,14.1667,9.16667C14.1667,9.16667,2.5,9.16667,2.5,9.16667C2.5,9.16667,2.5,15,2.5,15C2.5,15,5,15,5,15C5,15,5,15,5,15ZM1.66667,7.5C1.66667,7.5,15,7.5,15,7.5C15,7.5,15,5,15,5C15,5,10,5,10,5C10,5,10,1.66667,10,1.66667C10,1.66667,6.66667,1.66667,6.66667,1.66667C6.66667,1.66667,6.66667,5,6.66667,5C6.66667,5,1.66667,5,1.66667,5C1.66667,5,1.66667,7.5,1.66667,7.5C1.66667,7.5,1.66667,7.5,1.66667,7.5ZM0.833333,15.8333C0.833333,15.8333,0.833333,9.16667,0.833333,9.16667C0.833333,9.16667,0,9.16667,0,9.16667C0,9.16667,0,4.16667,0,4.16667C0,3.94565,0.0877975,3.73369,0.244077,3.57741C0.400358,3.42113,0.61232,3.33333,0.833333,3.33333C0.833333,3.33333,5,3.33333,5,3.33333C5,3.33333,5,0.833333,5,0.833333C5,0.61232,5.0878,0.400358,5.24407,0.244077C5.40036,0.0877975,5.61232,3.70074e-16,5.83333,0C5.83333,0,10.8333,0,10.8333,0C11.0543,3.70074e-16,11.2663,0.0877975,11.4226,0.244077C11.5788,0.400358,11.6667,0.61232,11.6667,0.833333C11.6667,0.833333,11.6667,3.33333,11.6667,3.33333C11.6667,3.33333,15.8333,3.33333,15.8333,3.33333C16.0543,3.33333,16.2663,3.42113,16.4226,3.57741C16.5788,3.73369,16.6667,3.94565,16.6667,4.16667C16.6667,4.16667,16.6667,9.16667,16.6667,9.16667C16.6667,9.16667,15.8333,9.16667,15.8333,9.16667C15.8333,9.16667,15.8333,15.8333,15.8333,15.8333C15.8333,16.0543,15.7455,16.2663,15.5892,16.4226C15.433,16.5788,15.221,16.6667,15,16.6667C15,16.6667,1.66667,16.6667,1.66667,16.6667C1.44565,16.6667,1.23369,16.5788,1.07741,16.4226C0.921133,16.2663,0.833333,16.0543,0.833333,15.8333C0.833333,15.8333,0.833333,15.8333,0.833333,15.8333Z"
                fill="#909399" fill-opacity="1" />
            </g>
          </svg> {{ $t('imageSplitter.clear') }}
        </div>
        <div class="main-split-operation-item cursor-pointer main-split-download" @click="handleDownload">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
            width="22.002376556396484" height="19.00220489501953" viewBox="0 0 22.002376556396484 19.00220489501953">
            <g>
              <path
                d="M0.0000010098,12.5022C-0.000614785,11.3977,0.280422,10.3112,0.816552,9.34551C1.35268,8.37981,2.1262,7.56676,3.064,6.98321C3.31151,5.05329,4.2538,3.27971,5.71452,1.99436C7.17524,0.709017,9.05428,-6.66134e-16,11,5.19079e-30C12.9457,-2.22045e-15,14.8248,0.709017,16.2855,1.99436C17.7462,3.27971,18.6885,5.05329,18.936,6.98321C20.0992,7.70689,21.0041,8.77961,21.5213,10.0482C22.0385,11.3168,22.1417,12.7163,21.8161,14.0471C21.4906,15.3778,20.7528,16.5716,19.7083,17.4581C18.6638,18.3445,17.366,18.8783,16,18.9832C16,18.9832,6,19.0022,6,19.0022C2.644,18.7282,0.0000010098,15.9242,0.0000010098,12.5022C0.0000010098,12.5022,0.0000010098,12.5022,0.0000010098,12.5022ZM15.848,16.9892C16.7938,16.9165,17.6925,16.5467,18.4156,15.9327C19.1387,15.3188,19.6493,14.492,19.8745,13.5704C20.0996,12.6489,20.0278,11.6798,19.6692,10.8016C19.3107,9.92334,18.6837,9.18086,17.878,8.68021C17.878,8.68021,17.071,8.17721,17.071,8.17721C17.071,8.17721,16.951,7.23521,16.951,7.23521C16.7641,5.78889,16.0569,4.46014,14.9616,3.49729C13.8663,2.53444,12.4578,2.00339,10.9995,2.00339C9.54116,2.00339,8.13272,2.53444,7.03742,3.49729C5.94213,4.46014,5.23493,5.78889,5.048,7.23521C5.048,7.23521,4.928,8.17721,4.928,8.17721C4.928,8.17721,4.123,8.68021,4.123,8.68021C3.3173,9.1808,2.69038,9.92319,2.3318,10.8014C1.97321,11.6795,1.90129,12.6485,2.12631,13.57C2.35133,14.4915,2.86177,15.3183,3.58475,15.9324C4.30773,16.5464,5.20625,16.9163,6.152,16.9892C6.152,16.9892,6.325,17.0022,6.325,17.0022C6.325,17.0022,15.675,17.0022,15.675,17.0022C15.675,17.0022,15.848,16.9892,15.848,16.9892C15.848,16.9892,15.848,16.9892,15.848,16.9892ZM12,10.0022C12,10.0022,15,10.0022,15,10.0022C15,10.0022,11,15.0022,11,15.0022C11,15.0022,7,10.0022,7,10.0022C7,10.0022,10,10.0022,10,10.0022C10,10.0022,10,6.00221,10,6.00221C10,6.00221,12,6.00221,12,6.00221C12,6.00221,12,10.0022,12,10.0022C12,10.0022,12,10.0022,12,10.0022Z"
                fill="#FFFFFF" fill-opacity="1" />
            </g>
          </svg> {{ $t('imageSplitter.download') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseMarkdown } from "./utils/MarkdownParser";
import { downloadAllImages } from "./utils/Download";
import RowsInput from "./components/RowsInput.vue";
const defaultRows = 3;
const defaultColumns = 3;
export default {
  data() {
    return {
      uploadFile: null,
      uploadFileName: null,
      rows: defaultRows,
      columns: defaultColumns,
      maxRows: 20,
      maxColumns: 20,
      minRows: 1,
      minColumns: 1,
      splitImages: [],
      splitImagesAll: null,
      imageLoading: false,
    };
  },
  components: {
    RowsInput,
  },
  methods: {
    handleClear() {
      this.uploadFile = null;
    },
    handleDownload() {
      if (!this.splitImagesAll) return;
      let imageItems = [];
      let fileName = this.uploadFileName.split('.')[0];
      for (let x = 0; x < this.splitImages.length; x++) {
        const row = this.splitImages[x];
        for (let y = 0; y < row.length; y++) {
          const image = row[y];
          imageItems.push({ url: image, fileName: `${fileName}-${x + 1}-${y + 1}`, fileType: 'png' });
        }
      }
      downloadAllImages(imageItems, fileName);
    },
    /**
     * 解析markdown
     * @param markdown 要解析的markdown内容
     * @returns 解析后的html内容
     */
    parseMarkdown(markdown) {
      // 这里要把当前组件this传入，因为需要它来获取路由的前缀
      return parseMarkdown(markdown, this);
    },
    /**
     * 处理文件上传
     */
    handleUpload() {
      this.$refs.uploadInput.click();
    },
    /**
     * 处理文件上传
     * @param event 
     */
    handleFileChange(event) {
      this.uploadFile = URL.createObjectURL(event.target.files[0]);
      this.uploadFileName = event.target.files[0].name;
      this.splitImage();
      setTimeout(() => {
        this.$refs.uploadInput.value = '';
      }, 0);
    },
    /**
     * 处理文件拖拽
     * @param event 拖拽事件对象
     */
    handleDrop(event) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        this.uploadFile = URL.createObjectURL(file)
        this.uploadFileName = file.name;
        this.splitImagesAll = null;
        this.splitImage();
      }
    },
    handleInputChange() {
      this.splitImage();
    },
    /**
     * 拆分图片
     */
    splitImage() {
      if (!this.uploadFile) return;
      this.imageLoading = true;
      this.splitImagesAll = null;
      let padding = 10;
      this.splitImages.length = 0;
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        // 搞一个画布，用来将拆分好的图片组合到一起
        const canvasAll = document.createElement('canvas');
        const ctxAll = canvasAll.getContext('2d');
        const { width, height } = img;
        padding = parseInt((width + height) / 2 / 100);
        if (padding < 1) padding = 1;
        const pieceWidth = width / this.columns;
        const pieceHeight = height / this.rows;
        canvasAll.width = width + (this.columns - 1) * padding; // 计算组合后的画布宽度
        canvasAll.height = height + (this.rows - 1) * padding; // 计算组合后的画布高度
        for (let y = 0; y < this.rows; y++) {
          this.$set(this.splitImages, y, []);
          for (let x = 0; x < this.columns; x++) {
            canvas.width = pieceWidth;
            canvas.height = pieceHeight;
            ctx.drawImage(
              img,
              x * pieceWidth,
              y * pieceHeight,
              pieceWidth,
              pieceHeight,
              0,
              0,
              pieceWidth,
              pieceHeight
            );
            ctxAll.drawImage(canvas, x * pieceWidth + x * padding, y * pieceHeight + y * padding, pieceWidth, pieceHeight);
            // 将每个小图片保存为Blob对象
            canvas.toBlob((blob) => {
              const url = URL.createObjectURL(blob);
              this.$set(this.splitImages[y], x, url);
            });
          }
        }
        canvasAll.toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          this.splitImagesAll = url;
          this.imageLoading = false;
        });
      };
      img.src = this.uploadFile;
    },
  },
  mounted() {
    // 监听拖拽事件
    window.addEventListener('drop', this.handleDrop);
    // 阻止默认拖拽行为
    window.addEventListener('dragover', event => event.preventDefault());
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener('drop', this.handleDrop);
    window.removeEventListener('dragover', event => event.preventDefault());
  }
};
</script>
<style>
body {
  background-color: #F9FAFB;
  margin: 0;
}

* {
  box-sizing: border-box;
}

.cursor-pointer {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
</style>
<style scoped>
.main-container {
  width: 100%;
  padding-bottom: 50px;
}

.main-title-container {
  background-image: url("./assets/title-bg.webp");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  padding: 30px;
  text-align: center;
  color: #fff;
  font-size: 24px;
}

.main-title {
  font-size: 50px;
  font-weight: bold;
  margin-bottom: 20px;
}

.main-upload-container {
  width: 90%;
  max-width: 600px;
  margin: 0 auto;
  box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  margin-top: 60px;
  padding: 32px;
}

.main-upload-input {
  display: none;
}

.main-upload {
  border: 2px dashed #D1D5DB;
  border-radius: 10px;
  padding: 70px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main-upload-icon {
  width: 60px;
  height: 42px;
}

.main-upload-text {
  margin-top: 17px;
  font-size: 16px;
  color: #4B5563;
  /* 换行 */
  white-space: pre-line;
  text-align: center;
}

.main-upload-button {
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 15px;
  gap: 0px 0px;
  background: #4762FF;
  color: #fff;
  font-size: 14px;
  margin-top: 34px;
}

.main-upload-button .el-icon-upload {
  font-size: 24px;
  margin-right: 9px;
}

.main-split-container {
  width: 95%;
  max-width: 766px;
  margin: 0 auto;
  margin-top: 60px;
  box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
  background-color: #DDE7FF;
  padding: 32px;
}

.main-split-mode-title {
  font-size: 18px;
  color: #374151;
  font-weight: bold;
  margin-bottom: 15px;
}

.split-rows-input {
  margin-right: 30px;
}

.main-split-preview-title {
  margin-top: 30px;
}

.main-split-preview-image {
  width: 600px;
  object-fit: cover;
  margin: 0 auto;
  max-height: 400px;
}

.main-split-preview-image img {
  width: 100%;
  max-height: 400px;
  object-fit: contain;
}

.main-split-operation {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
  align-items: center;
  gap: 10px;
}

.main-split-operation-item {
  min-width: 236px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  gap: 8px;
}

.main-split-clear {
  background: #F0F2F5;
  color: #909399;
}

.main-split-download {
  background: #000000;
  color: #fff;
}

.rows-input-solt {
  display: inline-block;
}

@media (max-width: 768px) {
  .main-split-container {
    padding-left: 10px;
    padding-right: 10px;
  }

  .main-upload-container {
    padding-left: 0;
    padding-right: 0;
  }

  .rows-input-container {
    display: block;
    margin-top: 10px;
  }

  .main-split-preview-image {
    width: 90%;
    object-fit: cover;
    margin: 0 auto;
    max-height: 400px;
  }

  .main-split-preview-image img {
    width: 100%;
    max-height: 400px;
    object-fit: contain;
  }

  .rows-input-solt {
    width: 100px;
  }
}
</style>
